import type { RouteObject } from "react-router";
import TherapeuticPlans from "./ui/pages/TherapeuticPlans";
import AddTherapeuticPlan from "./ui/pages/AddTherapeuticPlan";
import TherapeuticPlan from "./ui/pages/TherapeuticPlan";

export const therapeuticPlanRoutes: RouteObject[] = [
    { path: "/therapeutic-plans", element: <TherapeuticPlans /> },
    { path: "/therapeutic-plans/new", element: <AddTherapeuticPlan /> },
    { path: "/therapeutic-plans/:id", element: <TherapeuticPlan /> },
];
